<template>
  <div></div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('system', ['routerStatusRedirect']),
    ...mapState('contract', ['limitTransaction']),
  },
  async created() {
    console.log(`status check ${this.resultName}`)
    if (!this.limitTransaction) {
      await this.getLimitTransaction()
    }
    if ((await this.checkExistContract(this.limitTransaction)) === false) {
      await this.goContractLimitTransaction()
      return
    }

    const limitTransaction2 = await this.getContractsAgreementsMyfinbizService()
    if ((await this.checkExistContract(limitTransaction2)) === false) {
      await this.goContractLimitTransaction()
      return
    }

    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
  methods: {
    ...mapActions('contract', ['getLimitTransaction', 'checkExistContract']),
    ...mapActions('myfinbiz', ['getContractsAgreementsMyfinbizService']),
    async goContractLimitTransaction() {
      const name = 'signup/limit-transaction'
      if (this.$route.name !== name && this.routerStatusRedirect) {
        await this.$router.replace({ name })
      }
    },
  },
}
</script>
